<template>

    <footer>
        <div class="container">
            <div class="text-center mb-5">
                <img
                    :src="require('../../sass/sustainableclothing/img/logo-horizontal.png').default"
                    :alt="shopName"
                />
            </div>

            <div class="row">
                <div class="col-lg-4">
                    <h4>{{ lang('all.service') }}</h4>
                    <ol>
                        <li>
                            <inertia-link
                                :href="'/' + lang('menu.slugs.customerservice')"
                            >
                                {{ lang('all.klantenservice') }}
                            </inertia-link>
                        </li>
                        <li>
                            <inertia-link
                                :href="'/' + lang('menu.slugs.shippingcosts')"
                            >
                                {{ lang('all.verzendkosten') }}
                            </inertia-link>
                        </li>
                        <li>
                            <inertia-link
                                :href="'/' + lang('menu.slugs.returns')"
                            >
                                {{ lang('all.ruilen_en_retourneren') }}
                            </inertia-link>
                        </li>
                        <li>
                            <inertia-link
                                :href="'/' + lang('menu.slugs.paymentmethod')"
                            >
                                {{ lang('all.betaalwijzen') }}
                            </inertia-link>
                        </li>
                    </ol>
                </div>
                <div class="col-lg-4">
                    <h4>Sustainable Clothing Shop</h4>
                    <ol>
                        <li>
                            <i class="mdi mdi-email-outline"></i>
                            <a href="mailto:info@sustainableclothing.shop">info@sustainableclothing.shop</a>
                        </li>
                        <li>
                            <inertia-link
                                :href="route('content.index', {any: lang('menu.slugs.aboutus')})"
                            >{{ lang('menu.aboutus') }}</inertia-link>
                        </li>
                        <li>
                            <inertia-link
                                :href="route('content.index', {any: lang('menu.slugs.own-brand')})"
                            >{{ lang('menu.own-brand') }}</inertia-link>
                        </li>
                        <li>
                            <inertia-link href="/contact">{{ lang('all.contact') }}</inertia-link>
                        </li>
                    </ol>
                </div>
                <div class="col-lg-4">
                    <h4>{{ lang('all.beschikbaarheid') }}</h4>
                    <p>{{ lang('all.maandag_tm_vrijdag') }}<br />
                    {{ lang('all.0900_uur_tot_1700_uur') }}</p>

                    <p>{{ lang('all.zaterdag_gesloten') }}<br />
                    {{ lang('all.zondag_gesloten') }}</p>
                </div>
            </div>

            <div class="mt-5 row">
                <div class="col-lg-6">
                    <inertia-link
                        :href="'/' + lang('menu.slugs.tac')"
                    >
                        {{ lang('all.algemene_voorwaarden2') }}
                    </inertia-link>
                </div>
                <div class="col-lg-6">
                    <inertia-link
                        :href="'/' + lang('menu.slugs.privacypolicy')"
                    >
                        {{ lang('all.privacy_beleid') }}
                    </inertia-link>
                </div>
            </div>
        </div>
    </footer>

</template>

<script>

export default {

    computed: {
        shopName() {
            return this.$page.props.name;
        },
    },

    name:'ShopFooter',

}

</script>
